import { LogoutOutlined, SettingOutlined, UserOutlined } from '@ant-design/icons';
import { history, useModel } from '@umijs/max';
import { Spin } from 'antd';
import type { MenuProps } from 'antd';
import { createStyles } from 'antd-style';
import React, { useRef } from 'react';
import { flushSync } from 'react-dom';
import HeaderDropdown from '../HeaderDropdown';
import { removeItem } from '@/utils';
import {
  AUTO_LOGIN_STORIGE_KEY,
  REFRESH_TOKEN_STORIGE_KEY,
  TOKEN_STORIGE_KEY,
  TOKEN_TYPE,
} from '@/constants';
import EditPassWordModal, { EditPassWordModalRef } from './EditPassWordModal';

export type GlobalHeaderRightProps = {
  menu?: boolean;
  children?: React.ReactNode;
};

export const AvatarName = () => {
  const { initialState } = useModel('@@initialState');
  const { userInfo } = initialState || {};
  return <span className="anticon">{userInfo?.name}</span>;
};

const useStyles = createStyles(({ token }) => {
  return {
    action: {
      display: 'flex',
      height: '48px',
      marginLeft: 'auto',
      overflow: 'hidden',
      alignItems: 'center',
      padding: '0 8px',
      cursor: 'pointer',
      borderRadius: token.borderRadius,
      '&:hover': {
        backgroundColor: token.colorBgTextHover,
      },
    },
  };
});

export const AvatarDropdown: React.FC<GlobalHeaderRightProps> = ({ menu, children }) => {
  const { styles } = useStyles();

  const { initialState, setInitialState } = useModel('@@initialState');
  const editPassWordModalRef = useRef<EditPassWordModalRef>(null);

  const onMenuClick: MenuProps['onClick'] = (event) => {
    const { key } = event;
    if (key === 'logout') {
      flushSync(() => {
        removeItem(TOKEN_TYPE);
        removeItem(TOKEN_STORIGE_KEY);
        removeItem(AUTO_LOGIN_STORIGE_KEY);
        removeItem(REFRESH_TOKEN_STORIGE_KEY);
        setInitialState((s) => ({ ...s, userInfo: undefined, roleInfo: undefined }));
      });
      history.push('/login');
      return;
    }
    if (key === 'editpassword') {
      editPassWordModalRef.current?.open();
    }
  };

  const loading = (
    <span className={styles.action}>
      <Spin
        size="small"
        style={{
          marginLeft: 8,
          marginRight: 8,
        }}
      />
    </span>
  );

  if (!initialState) {
    return loading;
  }

  const { userInfo } = initialState;

  if (!userInfo || !userInfo.name) {
    return loading;
  }
  const menuItems = [
    ...(menu
      ? [
          {
            key: 'center',
            icon: <UserOutlined />,
            label: '个人中心',
          },
          {
            key: 'settings',
            icon: <SettingOutlined />,
            label: '个人设置',
          },
          {
            type: 'divider' as const,
          },
        ]
      : []),

    {
      key: 'editpassword',
      icon: <SettingOutlined />,
      label: (
        <div style={{width: 100}}  >
         修改密码
        </div >
      ),
    },
    {
      key: 'logout',
      icon: <LogoutOutlined />,
      label: (
        <div style={{width: 100}}  >
         退出登录
        </div >
      ),
    },
  ];

  return (
    <>
      {' '}
      <HeaderDropdown
        menu={{
          selectedKeys: [],
          onClick: onMenuClick,
          items: menuItems,
        }}
      >
        {children}
      </HeaderDropdown>
      <EditPassWordModal ref={editPassWordModalRef} />
    </>
  );
};
